import * as Yup from 'yup';

export const validationSchema = Yup.object({
  classes: Yup.array().min(1, "Моля, изберете поне една паралелка.")
});